import { DeleteConfirmDialog } from './delete-confirm-dialog.component';

export type AssetDeleteConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  assetName?: string;
};

export const AssetDeleteConfirmDialog = ({
  onClose,
  onConfirm,
  loading,
  assetName,
}: AssetDeleteConfirmDialogProps) => {
  const message = `This action will delete asset${assetName ? ` "${assetName}".` : ''}`;

  return (
    <DeleteConfirmDialog
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      message={message}
    />
  );
};
